import { render, staticRenderFns } from "./Contact.vue?vue&type=template&id=df212a54"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/websites/streamlined-business-solutions/sbs-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('df212a54')) {
      api.createRecord('df212a54', component.options)
    } else {
      api.reload('df212a54', component.options)
    }
    module.hot.accept("./Contact.vue?vue&type=template&id=df212a54", function () {
      api.rerender('df212a54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Contact.vue"
export default component.exports